import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import './auctionCard.css';

const AuctionCard = ({ product }) => {
  const { getText } = useTheme();
  const { t } = useTranslation();
  const [displayTimer, setDisplayTimer] = useState(product.timer || '00:00:00');

  useEffect(() => {
    // Se houver remainingSeconds, calcular e atualizar o timer a cada segundo
    if (product.remainingSeconds !== undefined && product.remainingSeconds > 0) {
      const timer = setInterval(() => {
        setDisplayTimer(prevTimer => {
          const parts = String(prevTimer).split(':');
          let seconds = parseInt(parts[2] || '0', 10);
          let minutes = parseInt(parts[1] || '0', 10);
          let hours = parseInt(parts[0] || '0', 10);

          seconds--;

          if (seconds < 0) {
            seconds = 59;
            minutes--;
          }

          if (minutes < 0) {
            minutes = 59;
            hours--;
          }

          if (hours < 0) {
            hours = 0;
            minutes = 0;
            seconds = 0;
          }

          return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [product.remainingSeconds]);

  const parts = String(displayTimer).split(':');
  const hours = parts[0] || '00';
  const minutes = parts[1] || '00';
  const seconds = parts[2] || '00';

  // URL da imagem padrão
  // Remove '/api' do final da URL da API para obter a raiz onde está a pasta uploads
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
  const baseUrl = apiUrl.endsWith('/api') ? apiUrl.slice(0, -4) : apiUrl;
  const defaultImage = `${baseUrl}/uploads/padrao.jpg`;

  return (
    <div className="card">
      <div className="card-media">
        <Link to={product.url}>
          <img
            src={product.image || defaultImage}
            alt={product.title}
            className="product-image"
            onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }}
          />
        </Link>
        <div className="top-badges">
          <div className="top-badges-left">
          </div>
          <div className="top-badges-right">
            {product.cashbackPercent && (
              <div className="badge-item cashback">
                ✔ {product.cashbackPercent}Cashback
              </div>
            )}
          </div>
        </div>
        <div className="bottom-overlay">
          <div className="timer-pills" aria-label={t('products.time_remaining')}>
            <span className="timer-pill">{hours}</span>
            <span className="timer-sep">:</span>
            <span className="timer-pill">{minutes}</span>
            <span className="timer-sep">:</span>
            <span className="timer-pill">{seconds}</span>
          </div>
        </div>
      </div>
      <div className="card-content">
        <h3 className="product-title">
          <Link to={product.url}>{product.title}</Link>
        </h3>
        <div className="price-row">
          <span className="current-price">{product.price}</span>
          <span className="market-price">{product.oldPrice}</span>
        </div>
        <div className="meta-row">
          <Link to={product.url} className="btn-view">{t('products.view_auction')}</Link>
        </div>
      </div>
    </div>
  );
};

export default AuctionCard;
